import { Component } from '@angular/core';
import { ValidationEmail } from '@net3-multiplatform-client/libs';

@Component({
  selector: 'app-validation-email',
  imports: [ValidationEmail],
  templateUrl: './validation-email.component.html'})
export class ValidationEmailPage {}
